import { callAgroApi } from '@services/agroapi';
import { PlaceResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
export const withPlaces = self => ({
  actions: {
    createPlace(place: {
      name: string;
      kind: string;
      address: string;
      annual_production_target?: number;
      capacity?: number;
    }) {
      return callAgroApi(`/organizations/${self.id}/places`, 'POST', place);
    },
    updatePlace(place) {
      return callAgroApi(`/places/${place.id}`, 'PATCH', place);
    },
    deletePlace(placeId: string) {
      return callAgroApi(`/places/${placeId}`, 'DELETE');
    },
    fetchPlaces({
      page = 1,
      search
    }: {
      page?: number;
      search?: string;
    }) {
      const queryParams = new URLSearchParams();
      if (search) {
        queryParams.set('filter[query]', search);
      }
      queryParams.set('page', page.toString());
      return callAgroApi<PlaceResponse[]>(`/organizations/${self.id}/places?${queryParams.toString()}`, 'GET').then(({
        data
      }) => data.map(d => Transformers.place(d)));
    },
    fetchPlace(id: string) {
      return callAgroApi<PlaceResponse>(`/places/${id}`, 'GET').then(({
        data
      }) => Transformers.place(data));
    }
  }
});